import { CheckedAgo } from '../../core/domain/status.model';

/**
 * How long ago a service was last probed, as a translation key and count ("geprüft vor 12 Min").
 * Rounded down, so a result never looks fresher than it is. Null without a check time.
 */
export function checkedAgo(lastCheckedUtc: string | null, now: Date = new Date()): CheckedAgo | null {
  if (!lastCheckedUtc) return null;

  const minutes = Math.max(0, Math.floor((now.getTime() - new Date(lastCheckedUtc).getTime()) / 60_000));
  if (minutes < 1) return { key: 'status.checkedAgo.now', count: 0 };
  if (minutes < 60) return { key: 'status.checkedAgo.minutes', count: minutes };

  const hours = Math.floor(minutes / 60);
  if (hours < 48) return { key: 'status.checkedAgo.hours', count: hours };

  return { key: 'status.checkedAgo.days', count: Math.floor(hours / 24) };
}
